module.exports = __webpack_public_path__ + "img/nvidia.08b58c7f.svg";